import { ECardType } from '../types/card'
import { EMediaType } from '../types/lot'
import { originalToken as originalTokenAPI, user as userAPI } from './api/index'

export async function sendFiles(
    id: string,
    contentType: EMediaType,
    file: File
) {
    if (contentType === EMediaType.VIDEO) {
        await originalTokenAPI.uploadVideo(id, file)
    }
    if (contentType === EMediaType.IMAGE) {
        await originalTokenAPI.uploadImage(id, file)
    }
}

export async function removeToken(id: string) {
    const yes = window.confirm('Are you really sure that you want to proceed?')
    if (!yes) return Promise.reject()
    await originalTokenAPI.delete(id)
}
export async function hideToken(id: string, type?: ECardType) {
    const yes = window.confirm(
        `This ${
            type === ECardType.premium ? 'content' : 'NFT'
        } will be hidden forever. You will not be able to restore it. Are you really sure that you want to proceed?`
    )
    if (!yes) return Promise.reject()
    await userAPI.tokenOriginal.hidden.create(id)
}
